import React from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import ChallengesTable from './sections/ChallengesTable/ChallengesTable';
import BdsButton from '../../../shared/components/v3/Buttons/BdsButton/BdsButton';
import PrimaryHero from '../../../shared/components/v3/Heros/PrimaryHero/PrimaryHero';
import { CREATE_CHALLENGE_ROUTE } from '../../../shared/constants/auth';
import { ADD_ICON } from '../../../shared/constants/images';
import { CLICK_ACTION, CREATE_CHALLENGE } from '../../../shared/constants/tagManager';
import TagManagerService from '../../../shared/services/gtm/tagManagerService';
import { TRANSLATION_CHALLENGES } from '../../../shared/translations/challenges';
import { redirectToPage } from '../../../shared/utils/utils';

import './ChallengesMain.scss';

const ChallengesMain = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onCreateChallengeClick = () => {
    TagManagerService.pushEvent(CLICK_ACTION, CREATE_CHALLENGE);
    redirectToPage(navigate, CREATE_CHALLENGE_ROUTE);
  };

  return (
    <div className="challenges-container">
      <PrimaryHero
        title={t(TRANSLATION_CHALLENGES.hero.mainChallenge.title)}
        color="accent-quaternary"
        bottomContent={
          <div className="challenges-hero-button">
            <BdsButton action={onCreateChallengeClick} variant="primary" size="m" iconLeft={ADD_ICON}>
              {t(TRANSLATION_CHALLENGES.hero.mainChallenge.button)}
            </BdsButton>
          </div>
        }
      />

      <div className="challenges-table-container">
        <ChallengesTable />
      </div>
    </div>
  );
};

export default ChallengesMain;
